export const AllAnnotationsConstants = {
    ALL_COLORS: "all_colors",
    COLORS_LIST: ["#36454f", "#7CFC00", "#e91e63", "#9c27b0", "#3f51b5", "#2196f3", "#FF69B4", "#008000", "#FF8C00"],
    DEFAULT_ANNO_COLOR: "#36454f",
    LINE: "line",
    POLYGON: "polygon",
    CIRCLE: "circle"
}